export default [
  {id: 1, type: 'Typen'},
  {id: 2, type: 'Songs'},
  {id: 3, type: 'Release'},
  {id: 4, type: 'Land'},
  {id: 5, type: 'Stores'},
]
